<template>
  <TransactionList apiParams="1722"/>
</template>
<style>
.sc-card-pan {
  direction: ltr;
}
.ltrdir {
  direction: ltr;
}
</style>
<script>

import TransactionList from "./TransactionList";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "dollarTransactionList",
  data() {
    return {
    };
  },
  components: {
    TransactionList
  },
  created() {
    
  },
  methods: {
    
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تراکنش های دلاری" }]);
  },
};
</script>
